import CreateYearFilter from "./CreateYearFilter";
import MediumFilter from "./MediumFilter";
import StyleFilter from "./StyleFilter";
import PriceRangeFilter from "./PriceRangeFilter";
import SizeRangeFilter from "./SizeRangeFilter";
import SubjectFilter from "./SubjectFilter";
import BusinessTypeFilter from "./BusinessTypeFilter";
import ColorFilter from "./ColorFilter";
import CollectionFilter from "./CollectionFilter";
import InStockFilter from "./InStockFilter";
import CityFilter from "./CityFilter";
import TagFilter from "./TagFilter";
import StateFilter from "./StateFilter";
import SingleSelectTypeFilter from "./SingleSelectTypeFilter";
import OrderTypeFilter from "./OrderTypeFilter";

export const TYPE_CREATE_YEAR = 'create_year'
export const TYPE_MEDIUM = 'medium'
export const TYPE_STYLE = 'style'
export const TYPE_PRICE_RANGE = 'price_range'
export const TYPE_SIZE_RANGE = 'size_range'
export const TYPE_SUBJECT = 'subject'
export const TYPE_BUSINESS_TYPE = 'business_type'
export const TYPE_COLOR = 'color'
export const TYPE_IN_COLLECTION = 'in_collection'
export const TYPE_IN_STOCK = 'in_stock'
export const TYPE_CITY = 'city'
export const TYPE_TAG = 'tag'
export const TYPE_STATE = 'state'
export const SINGLE_SELECT_TYPE_TAG = 'single_select'
export const TYPE_ORDER = 'order'

export function initMultipleFilter(f) {
    if (!f) {
        f = []
    } else {
        f = f.split(',')
    }
    return f
}

export function getFiltersByType(type, props) {
    switch (type) {
        case TYPE_CREATE_YEAR:
            return <CreateYearFilter {...props}/>
        case TYPE_MEDIUM:
            return <MediumFilter {...props}/>
        case TYPE_STYLE:
            return <StyleFilter {...props}/>
        case TYPE_PRICE_RANGE:
            return <PriceRangeFilter {...props}/>
        case TYPE_SIZE_RANGE:
            return <SizeRangeFilter {...props}/>
        case TYPE_SUBJECT:
            return <SubjectFilter {...props}/>
        case TYPE_BUSINESS_TYPE:
            return <BusinessTypeFilter {...props}/>
        case TYPE_COLOR:
            return <ColorFilter {...props}/>
        case TYPE_IN_COLLECTION:
            return <CollectionFilter {...props}/>
        case TYPE_IN_STOCK:
            return <InStockFilter {...props} />
        case TYPE_CITY:
            return <CityFilter {...props} />
        case TYPE_TAG:
            return <TagFilter {...props} />
        case TYPE_STATE:
            return <StateFilter {...props} />
        case SINGLE_SELECT_TYPE_TAG:
            return <SingleSelectTypeFilter {...props} />
        case TYPE_ORDER:
            return <OrderTypeFilter {...props}/>
    }
}